import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";
import { Trash, Plus } from "@phosphor-icons/react";

export const ShiftsSection = () => {
  const [shifts, setShifts] = useState([]);
  const [newShift, setNewShift] = useState({ name: "", start_time: "09:00", end_time: "18:00" });

  const load = () => api.get("/shifts").then((r) => setShifts(r.data));
  useEffect(() => { load(); }, []);

  const addShift = async (e) => {
    e.preventDefault();
    try {
      await api.post("/shifts", newShift);
      toast.success("Shift added");
      setNewShift({ name: "", start_time: "09:00", end_time: "18:00" });
      load();
    } catch (err) { toast.error(errText(err)); }
  };

  const delShift = async (id) => {
    await api.delete(`/shifts/${id}`);
    toast.success("Shift removed");
    load();
  };

  return (
    <section className="bg-white border border-stone-200 rounded-lg p-6 space-y-4">
      <h3 className="font-heading font-bold">Shifts</h3>
      <div className="divide-y divide-stone-100">
        {shifts.map((s) => (
          <div key={s.id} className="py-3 flex items-center justify-between text-sm">
            <span className="font-semibold">{s.name}</span>
            <span className="flex items-center gap-3">
              <span className="tabular-nums text-stone-500">{s.start_time} – {s.end_time}</span>
              <button onClick={() => delShift(s.id)} data-testid={`delete-shift-${s.id}`}
                className="w-8 h-8 flex items-center justify-center rounded-full text-stone-400 hover:text-red-600 transition-colors duration-200"><Trash size={15} /></button>
            </span>
          </div>
        ))}
      </div>
      <form onSubmit={addShift} className="flex flex-wrap items-end gap-3">
        <div className="flex-1 min-w-[140px]">
          <label className="text-xs font-semibold text-stone-500">Shift name</label>
          <input required placeholder="Night" value={newShift.name} onChange={(e) => setNewShift({ ...newShift, name: e.target.value })} data-testid="new-shift-name" className="mt-1 block w-full min-h-[44px] px-3 rounded-lg border border-stone-300" />
        </div>
        <div>
          <label className="text-xs font-semibold text-stone-500">Start</label>
          <input type="time" required value={newShift.start_time} onChange={(e) => setNewShift({ ...newShift, start_time: e.target.value })} data-testid="new-shift-start" className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300" />
        </div>
        <div>
          <label className="text-xs font-semibold text-stone-500">End</label>
          <input type="time" required value={newShift.end_time} onChange={(e) => setNewShift({ ...newShift, end_time: e.target.value })} data-testid="new-shift-end" className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300" />
        </div>
        <button type="submit" data-testid="add-shift-button" className="tap-scale flex items-center gap-1 px-5 py-3 rounded-full bg-primary text-white text-sm font-bold hover:bg-[#A63F07] transition-colors duration-200"><Plus size={16} weight="bold" /> Add</button>
      </form>
    </section>
  );
};
